const hotKeys = [];

export const getHotKeys = () => {
  return hotKeys;
};

export const registerHotKeys = (config) => {
  config.forEach((item) => {
    const { hotkey } = item;

    if (Array.isArray(hotkey)) {
      hotkey.forEach((key) => {
        hotKeys.push({
          ...item,
          hotkey: key,
        });
      });
    } else {
      hotKeys.push(item);
    }
  });
};
